import { Navigate, Outlet } from 'react-router-dom';
import { useIsAdmin } from '@/hooks/useAdmin';
import LoadingPage from '@/components/ui/LoadingPage';

/**
 * Guards the admin viewport. Rendering nothing while the profile loads is deliberate:
 * redirecting on a not-yet-known role would bounce an admin out on every page refresh.
 */
export function AdminRoute() {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isAdmin) {
    return <Navigate to="/patients" replace />;
  }

  return <Outlet />;
}
